import { Box } from '@chakra-ui/react';
import { DocumentStream, DocumentStreamNote } from '@codametrix/shared-views';
import React from 'react';

import { useNoteInteraction } from './noteInteractionContext';
import { cmxDocumentContentLabel } from './cmxDocumentContentLabel';
import type { CmxDocumentContentSlotData } from './cmxDocumentContentSlot';
import { CmxDocumentContentViewer } from './CmxDocumentContentViewer';

export const CmxDocumentContentStream: React.FC<{
  readonly cmxDocumentContents: CmxDocumentContentSlotData;
}> = ({ cmxDocumentContents }) => {
  const { focusRequest, setNoteInView } = useNoteInteraction();
  const notes = cmxDocumentContents.map((entry, index) => ({
    key: entry.documentId,
    label: cmxDocumentContentLabel(entry, index)
  }));

  return (
    <Box
      role="region"
      aria-label="CMX Document Contents"
      data-testid="cmx-document-content-stream"
      pt={4}
      sx={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}
    >
      <DocumentStream
        notes={notes}
        focusRequest={focusRequest}
        onNoteInView={setNoteInView}
      >
        {cmxDocumentContents.map((entry) => (
          <DocumentStreamNote key={entry.documentId} noteKey={entry.documentId}>
            <CmxDocumentContentViewer value={entry} />
          </DocumentStreamNote>
        ))}
      </DocumentStream>
    </Box>
  );
};
